import { Box, Button, Divider, Grid, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

export default function Bloque6({ text61, text62, handleDatosTextField61, handleDatosTextField62, text7, handleDatosTextField7 }) {

    useEffect(() => {
        console.log(text61)
        console.log(text62)
    }, [text61, text62])

    const [mostrar, setMostrar] = useState(false)

    const handleMostrar = () => {
        setMostrar(!mostrar)
    }

    return (
        <div>
            <Box style={{ marginTop: "0px" }} >
                <Box style={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography style={{ fontSize: "17px", marginTop: "20px" }} ><b>Gonioscopía</b></Typography>
                    <Button variant='outlined' style={{ marginTop: "10px" }} onClick={handleMostrar}>{mostrar ? "Ocultar Valores" : "Mostrar Valores"}</Button>
                </Box>
                {
                    mostrar &&
                    <>
                        <Box style={{ display: "flex", justifyContent: "space-around" }}>
                            <Box>
                                <Box style={{ textAlign: "center", marginLeft: "-100px" }}>
                                    <Typography variant='h5'>Ojo Iquierdo</Typography>
                                </Box>
                                <Box style={{ display: "flex", flexWrap: "wrap", width: "350px", gap: "10px" }}>
                                    {
                                        text61.map((x, ix) =>
                                            <Box key={ix} style={{ width: x.id === 1 || x.id === 4 ? "300px" : "80px", minHeight: "45px", marginLeft: x.id === 1 || x.id === 4 ? "75px" : 20, marginTop: "0px" }}>
                                                <TextField
                                                    value={x.ojoi}
                                                    style={{ width: "100px", minHeight: "30px !important" }}
                                                    onChange={(e) => handleDatosTextField61(x.id, e.target.value, 'ojoi')}
                                                    type='number'
                                                />
                                            </Box>
                                        )
                                    }

                                </Box>
                            </Box>
                            <Box>
                                <Box style={{ textAlign: "center", marginLeft: "-100px" }}>
                                    <Typography variant='h5'>Ojo Derecho</Typography>
                                </Box>
                                <Box style={{ display: "flex", flexWrap: "wrap", width: "350px", gap: "10px" }}>
                                    {
                                        text62.map((x, ix) =>
                                            <Box key={ix} style={{ width: x.id === 1 || x.id === 4 ? "300px" : "80px", minHeight: "45px", marginLeft: x.id === 1 || x.id === 4 ? "75px" : 20, marginTop: "0px" }}>
                                                <TextField
                                                    value={x.ojod}
                                                    style={{ width: "100px", minHeight: "30px !important" }}
                                                    onChange={(e) => handleDatosTextField62(x.id, e.target.value, 'ojod')}
                                                    type='number'
                                                />
                                            </Box>)
                                    }

                                </Box>
                            </Box>
                        </Box>

                        <Box style={{ marginTop: "50px" }} >
                            <Typography style={{ marginBottom: "20px" }} variant="h4" >Observaciones de Gonioscopía</Typography>

                            {
                                text7.map(x =>
                                    <Grid container>
                                        <Grid lg={12}>
                                            <Box>
                                                <TextField
                                                    label={x.label}
                                                    multiline
                                                    fullWidth
                                                    rows={7}
                                                    onChange={(e) => handleDatosTextField7(x.id, e.target.value, 'gionocopia')}
                                                    value={x.gionocopia}
                                                />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                )
                            }
                        </Box>
                    </>



                }

            </Box>



            <Divider style={{ marginTop: "15px" }} />
        </div>
    )
}
